import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
type PropertyCardProps = {
  name: string;
  imageUrl: string;
};
export function PropertyCard({
  name,
  imageUrl
}: PropertyCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-144">
      <Card className="overflow-hidden" data-id="element-145">
        <div className="relative" data-id="element-146">
          {/* Property Image */}
          <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-147">
            <img src={imageUrl} alt={name} className="w-full h-full object-cover" data-id="element-148" />
          </div>
        </div>

        {/* Property Info */}
        <div className="p-6" data-id="element-149">
          <h2 className="text-xl font-bold text-navy" data-id="element-150">{name}</h2>
        </div>
      </Card>
    </motion.div>;
}